import * as React from 'react';
import { Link } from 'react-router';
import styled from 'styled-components';
import { rem, rgba } from 'polished';
import { TextP } from '../../../Defaults/Text';
import { FlexCol, FlexRow } from '../../../Defaults/Flexbox/Flexbox';
import { resolveCurrencySignFromCurrency } from '../../../../utilities/selectors';
import { __ } from 'react-i18n';
import { getImagePath, prop, round } from '../../../../utilities';

export interface Props {
  products: any;
  handleClose: () => void;
  router: any;
}

function AddedToCartBoughtTooMobile({ products, handleClose, router }: Props) {
  return (
    <Wrapper>
      {products.map((item, index) => {
        const goodWithPrice = prop(item, 'goods', []).filter(
          good => good.unitprice > 0,
        );

        const handleOnClick = () => {
          handleClose();
          router.push(`/produkt/${item.product_id}/${item.url}`);
        };

        let price = prop(goodWithPrice, '0.unitprice', 0);
        if (typeof price === 'number') {
          price = round(price, 2).toFixed(2);
        }

        return (
          <ProductWrapper key={index}>
            <LeftWrapper>
              {' '}
              <ProductImg
                alt={item.name}
                src={getImagePath(
                  process.env.REACT_APP_API_BASE_URL
                    ? process.env.REACT_APP_API_BASE_URL
                    : '',
                  item.picture,
                  { width: 48, height: 48 },
                )}
                onClick={handleOnClick}
              />{' '}
              <ProductInfo>
                <Name onClick={handleOnClick}>{item.name}</Name>
                <ItemPrice>
                  {price}{' '}
                  {resolveCurrencySignFromCurrency(
                    prop(item, 'main_good.currency_id', 'EUR'),
                  )}
                </ItemPrice>
              </ProductInfo>
            </LeftWrapper>

            <RedirectButton>
              <StyledButton
                to={`/produkt/${item.product_id}/${item.url}`}
                onClick={handleClose}
              >
                {__('Detail')}{' '}
              </StyledButton>
            </RedirectButton>
          </ProductWrapper>
        );
      })}
    </Wrapper>
  );
}

const Wrapper = styled(FlexCol)`
  max-height: ${rem(200)};
  overflow-y: scroll;
  justify-content: flex-start;
`;
const ProductWrapper = styled(FlexRow)`
  border-bottom: 1px solid ${rgba('#000', 0.1)};
  justify-content: space-between;
  align-items: center;
  :last-child {
    border-bottom: none;
  }
`;

const ProductImg = styled.img`
  margin: auto;
  min-width: 48px;
  height: 48px;
  max-height: 48px;
  max-width: 48px;
`;
const ProductInfo = styled.div`
  padding: ${rem(16)};
`;
const Name = styled(TextP)`
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: ${rem(14)};
  line-height: ${rem(18)};
  margin-bottom: ${rem(4)};
`;
const ItemPrice = styled(TextP)`
  font-family: 'Roboto', sans-serif;
  font-weight: 700;
  font-size: ${rem(14)};
  line-height: 1.2;
  margin-top: ${rem(4)};
`;
const RedirectButton = styled.div``;
const StyledButton = styled(Link)`
  width: ${rem(60)};
  height: ${rem(32)};
  background: #2cc5b7;
  border-radius: 4px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: ${rem(14)};
`;
const LeftWrapper = styled(FlexRow)``;

export { AddedToCartBoughtTooMobile };
